import axios from "../axiosHelper";
import Cookies from "js-cookie";

export default {
  state: {
    status: "",
    status_code: "",
    message: "",
    message_code: "",
    currentSubjectId: Cookies.get("currentSubjectId") || null,
    subjectList: [{}],
    laList: [{}],
    modulList: [{}],
    classList: [{}],
    subjectDetail: {},
  },
  getters: {
    getCurrentSubjectId: (state) => state.currentSubjectId,
    getSubjectList: (state) => state.subjectList,
    getSubjectListFilter: (state) => state.subjectList,
    getLaListFilter: (state) => state.laList,
    getModulListFilter: (state) => state.modulList,
    getClassListSubject: (state) => state.classList,
    getSubjectDetail: (state) => state.subjectDetail,
  },
  mutations: {
    request(state) {
      state.status = "LOADING";
    },
    success(state, { resp }) {
      state.status = "SUCCESS";
      if (resp) {
        state.status_code = resp.data.status;
        state.message = resp.data.message;
        state.message_code = resp.data.code;
      }
    },
    error(state, { resp }) {
      state.status = "ERROR";
      if (resp) {
        state.status_code = resp.data.status;
        state.message = resp.data.message;
        state.message_code = resp.data.code;
      }
    },
    setSubjectList(state, { resp }) {
      if (resp) {
        state.subjectList = resp.data.data;
      }
    },
    setLaList(state, { resp }) {
      if (resp) {
        state.laList = resp.data.data;
      }
    },
    setModulList(state, { resp }) {
      if (resp) {
        state.modulList = resp.data.data;
      }
    },
    setClassList(state, { resp }) {
      if (resp) {
        state.classList = resp.data.data;
      }
    },
    setSubjectDetail(state, { resp }) {
      if (resp) {
        state.subjectDetail = resp.data.data;
      }
    },
    setCurrentSubjectId(state, { form }) {
      Cookies.set("currentSubjectId", form.subjectId);
    },
  },
  actions: {
    setCurrentSubjectId({ commit }, form) {
      commit("setCurrentSubjectId", { form });
    },
    addSubject({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/add?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    copySubject({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/copy?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    editSubject({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/edit?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    deleteSubject({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/delete?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getSubjectDetail({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/get-overview/" + param.subjectId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setSubjectDetail", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getSubjectList({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/" + param.classId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setSubjectList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getSubjectListFilter({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/list/" + param.classId + "/" + param.semester + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setSubjectList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getLaListFilter({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/la-list/" + param.subjectId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setLaList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getModulListFilter({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/modul-list/" + param.laId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setModulList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getClassListSubject({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/subjects/class-list/" + param.classId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setClassList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
  },
};
